(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2449],{

/***/ 30052:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/item/[slug]",
      function () {
        return __webpack_require__(11535);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 60640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$c": function() { return /* binding */ DesignerHeader; },
/* harmony export */   "Bc": function() { return /* binding */ ErrorMessage; },
/* harmony export */   "C7": function() { return /* binding */ AfterPay; },
/* harmony export */   "FC": function() { return /* binding */ VariantPickerB; },
/* harmony export */   "FM": function() { return /* binding */ RentButton; },
/* harmony export */   "HF": function() { return /* binding */ RemoveIcon; },
/* harmony export */   "Jk": function() { return /* binding */ ChangeDatePickerB; },
/* harmony export */   "Ln": function() { return /* binding */ BagIcon; },
/* harmony export */   "PP": function() { return /* binding */ DeliveryDate; },
/* harmony export */   "aH": function() { return /* binding */ AddToCartSelection; },
/* harmony export */   "dy": function() { return /* binding */ ChangeDatePicker; },
/* harmony export */   "ez": function() { return /* binding */ UndiscountedPrice; },
/* harmony export */   "fH": function() { return /* binding */ VariantPicker; },
/* harmony export */   "go": function() { return /* binding */ ProductPricing; },
/* harmony export */   "ox": function() { return /* binding */ ProductNameHeader; },
/* harmony export */   "qA": function() { return /* binding */ PickBoxes; },
/* harmony export */   "vH": function() { return /* binding */ ProductSizeHeader; },
/* harmony export */   "vI": function() { return /* binding */ ProductDescription; },
/* harmony export */   "zM": function() { return /* binding */ AlertIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16829);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63319);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        padding-top: 0;\n        padding-bottom: 0.5rem;\n        font-size: 16px;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      font-size: 16px;\n      color: #71797e;\n      font-weight: ",
        ";\n      padding-top: ",
        ";\n      text-align: left;\n\n      &:hover {\n        color: ",
        ";\n      }\n\n      svg {\n        color: ",
        ";\n        font-size: 28px;\n        margin-top: -3px;\n        font-weight: 100;\n      }\n\n      ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        padding-top: 0;\n        font-size: ",
        ";\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      text-transform: uppercase;\n      font-size: ",
        ";\n      font-weight: ",
        ";\n      padding-top: ",
        ";\n      text-align: left;\n\n      ",
        ";\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      font-size: ",
        ";\n      margin-top: 5px;\n      margin-bottom: 27px;\n      text-align: left;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      font-weight: ",
        ";\n      margin-bottom: 5px;\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 5px;\n      font-size: ",
        ";\n      margin-bottom: 16px;\n      padding: 12px;\n      background-color: ",
        ";\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      font-size: ",
        ";\n      margin-bottom: ",
        ";\n      color: #a1a1a1;\n      display: flex;\n      align-items: center;\n      gap: 5px;\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        display: block;\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      font-size: ",
        ";\n      margin-bottom: ",
        ";\n      display: none;\n\n      ",
        ";\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      text-decoration: line-through;\n      color: ",
        ";\n      font-size: ",
        ";\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      display: grid;\n      margin-top: 20px;\n      width: 280px;\n      justify-items: start;\n\n      .react-select-wrapper,\n      .input {\n        width: 75%;\n        margin-bottom: ",
        ";\n      }\n\n      .chakra-button {\n        height: 45px;\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        width: 100%;\n      }\n    "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      display: grid;\n      margin-top: 20px;\n      width: 280px;\n      justify-items: start;\n\n      .react-select-wrapper,\n      .input {\n        width: 75%;\n        margin-bottom: ",
        ";\n      }\n\n      .chakra-button {\n        height: auto;\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        width: 100%;\n        border: none;\n        justify-items: start;\n        padding: 0;\n        text-decoration: underline;\n      }\n\n      .chakra-button:hover {\n        background-color: white;\n        color: blue;\n        text-decoration: underline;\n      }\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 100%;\n\n      .react-select-wrapper,\n      .input {\n        width: 75%;\n        margin-bottom: ",
        ";\n      }\n\n      .chakra-button {\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        width: 100%;\n      }\n    "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 100%;\n\n      .react-select-wrapper,\n      .input {\n        width: 75%;\n        margin-bottom: ",
        ";\n      }\n\n      .chakra-button {\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        width: 100%;\n        border: none;\n        padding: 0;\n        text-decoration: underline;\n      }\n\n      .chakra-button:hover {\n        background-color: white;\n        color: blue;\n        text-decoration: underline;\n      }\n    "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      .chakra-button {\n        height: 100%;\n        font-weight: ",
        ";\n      }\n\n      input {\n        padding: 0.3rem 1rem;\n      }\n    "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-left: 10px;\n      margin-right: 10px;\n\n      .chakra-button {\n        width: 100%;\n        height: 48px;\n        font-weight: ",
        ";\n        border-radius: 8px;\n      }\n    "
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  path {\n    fill: white;\n  }\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  path {\n    fill: black;\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 5px;\n\n  svg {\n    height: 24px;\n    width: 24px;\n  }\n\n  span {\n    height: 24px;\n    width: 24px;\n  }\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}



var AddToCartSelection = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject());
var DesignerHeader = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].a */ .Z.a(_templateObject3(), function(param) {
    var theme = param.theme;
    var typography = theme.typography, space = theme.space;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), typography.extraBoldFontWeight, space[3], theme.colors.tertiaryLight, theme.colors.tertiaryLight, _styles__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject1()));
});
var ProductNameHeader = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h1 */ .Z.h1(_templateObject6(), function(param) {
    var theme = param.theme;
    var typography = theme.typography, space = theme.space;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5(), typography.h4FontSize, typography.extraBoldFontWeight, space[3], _styles__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject4(), typography.baseFontSize));
});
var ProductSizeHeader = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3 */ .Z.h3(_templateObject8(), function(param) {
    var theme = param.theme;
    var typography = theme.typography;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), typography.h4FontSize);
});
var ProductPricing = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h4 */ .Z.h4(_templateObject10(), function(param) {
    var theme = param.theme;
    var typography = theme.typography;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject9(), typography.boldFontWeight);
});
var DeliveryDate = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h4 */ .Z.h4(_templateObject12(), function(param) {
    var theme = param.theme;
    var typography = theme.typography, colors = theme.colors;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject11(), typography.smallFontSize, colors.successGreen);
});
var AfterPay = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p */ .Z.p(_templateObject14(), function(param) {
    var theme = param.theme;
    var typography = theme.typography, spacing = theme.spacing;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject13(), typography.smallFontSize, spacing.spacer);
});
var ProductDescription = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p */ .Z.p(_templateObject17(), function(param) {
    var theme = param.theme;
    var typography = theme.typography, spacing = theme.spacing;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject16(), typography.smallFontSize, spacing.spacer, _styles__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject15()));
});
var UndiscountedPrice = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span(_templateObject19(), function(param) {
    var theme = param.theme;
    var typography = theme.typography, colors = theme.colors;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject18(), colors.baseFontColorSemiTransparent, typography.smallFontSize);
});
var VariantPicker = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject21(), function(param) {
    var theme = param.theme;
    var typography = theme.typography, spacing = theme.spacing;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject20(), spacing.spacer, theme.typography.baseFontSize, typography.extraBoldFontWeight);
});
var ChangeDatePicker = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject23(), function(param) {
    var theme = param.theme;
    var spacing = theme.spacing, typography = theme.typography;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject22(), spacing.spacer, theme.typography.baseFontSize, typography.extraBoldFontWeight);
});
var VariantPickerB = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject25(), function(param) {
    var theme = param.theme;
    var typography = theme.typography, spacing = theme.spacing;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject24(), spacing.spacer, theme.typography.baseFontSize, typography.extraBoldFontWeight);
});
var ChangeDatePickerB = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject27(), function(param) {
    var theme = param.theme;
    var spacing = theme.spacing, typography = theme.typography;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject26(), spacing.spacer, theme.typography.baseFontSize, typography.extraBoldFontWeight);
});
var ErrorMessage = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p */ .Z.p(_templateObject28(), function(props) {
    return props.theme.colors.error;
});
// export const PickBoxes = styled.div`
//   .chakra-button {
//     height: 100%;
//     font-weight: ${typography.extraBoldFontWeight};
//   }
//   input {
//     padding: 0.3rem 1rem;
//   }
// `;
var PickBoxes = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject30(), function(param) {
    var theme = param.theme;
    var typography = theme.typography;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject29(), typography.extraBoldFontWeight);
});
var RentButton = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject32(), function(param) {
    var theme = param.theme;
    var typography = theme.typography;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject31(), typography.extraBoldFontWeight);
});
var BagIcon = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject33());
var RemoveIcon = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject34());
var AlertIcon = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject35());


/***/ }),

/***/ 97712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ structuredDataAggregateReviews; },
/* harmony export */   "n": function() { return /* binding */ structuredData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);


var getVariantsStructuredData = function(variants, productCondition) {
    var inStock = "https://schema.org/InStock";
    var outOfStock = "https://schema.org/OutOfStock";
    return variants.map(function(variant) {
        return {
            "@type": "Offer",
            priceCurrency: variant.pricing.price.gross.currency,
            price: (variant.pricing.price.gross.amount + variant.pricing.borrowerFee.gross.amount).toFixed(2),
            itemCondition: (productCondition === null || productCondition === void 0 ? void 0 : productCondition.slug) === "new" || (productCondition === null || productCondition === void 0 ? void 0 : productCondition.slug) === "new-with-tags" ? "https://schema.org/NewCondition" : "https://schema.org/UsedCondition",
            availability: variant.quantityAvailable > 0 ? inStock : outOfStock
        };
    });
};
function getProductBrand(product) {
    var ref;
    var designerAttribute = product === null || product === void 0 ? void 0 : (ref = product.attributes) === null || ref === void 0 ? void 0 : ref.find(function(param) {
        var attribute = param.attribute;
        return (attribute === null || attribute === void 0 ? void 0 : attribute.name) === "Designer";
    });
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((designerAttribute === null || designerAttribute === void 0 ? void 0 : designerAttribute.values) || [], 1), designerValue = ref1[0];
    return (designerValue === null || designerValue === void 0 ? void 0 : designerValue.name) || "";
}
var getSku = function(variants) {
    if (Array.isArray(variants) && variants.length > 0) {
        var _sku;
        return (_sku = variants[0].sku) !== null && _sku !== void 0 ? _sku : "";
    }
    return "";
};
var structuredData = function(product) {
    var ref, ref1;
    var images = product.images.map(function(image) {
        return new URL(image.url);
    });
    var productConditionAttribute = product === null || product === void 0 ? void 0 : (ref = product.attributes) === null || ref === void 0 ? void 0 : ref.find(function(attr) {
        return attr.attribute.slug === "condition";
    });
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((productConditionAttribute === null || productConditionAttribute === void 0 ? void 0 : productConditionAttribute.values) || [], 1), productCondition = ref2[0];
    var variants = product.variants;
    var productDescription = "";
    try {
        var ref3, ref4, ref5;
        var descriptionData = JSON.parse(product.description);
        productDescription = (ref5 = (ref4 = descriptionData === null || descriptionData === void 0 ? void 0 : (ref3 = descriptionData.blocks) === null || ref3 === void 0 ? void 0 : ref3.filter(function(block) {
            return (block === null || block === void 0 ? void 0 : block.type) === "paragraph";
        })) === null || ref4 === void 0 ? void 0 : ref4.map(function(block) {
            var ref, ref1;
            return block === null || block === void 0 ? void 0 : (ref = block.data) === null || ref === void 0 ? void 0 : (ref1 = ref.text) === null || ref1 === void 0 ? void 0 : ref1.trim();
        })) === null || ref5 === void 0 ? void 0 : ref5.join(". ");
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error parsing product description:", error);
    }
    productDescription = (product === null || product === void 0 ? void 0 : product.seoDescription) || productDescription || product.name;
    return JSON.stringify((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        "@context": "https://schema.org/",
        "@type": "Product",
        name: product === null || product === void 0 ? void 0 : (ref1 = product.name) === null || ref1 === void 0 ? void 0 : ref1.trim(),
        image: images,
        description: productDescription,
        brand: {
            "@type": "Brand",
            name: getProductBrand(product)
        },
        offers: getVariantsStructuredData(variants, productCondition),
        sku: getSku(variants),
        url: location.href
    }, !!(product === null || product === void 0 ? void 0 : product.productAggregateRating) && {
        aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: product.productAggregateRating.ratingValue,
            ratingCount: product.productAggregateRating.ratingCount
        }
    }));
};
/*
We should be getting this directly from Google, however it is suprisingly difficult.

Using the places API would be the simplest, however since we don't have a physical 
address, it doesn't work.

(Our place_id: ChIJvd_NtezkT2ERjXpVP5iszM0)

https://maps.googleapis.com/maps/api/place/details/json?key={{GOOGLE_PLACES_API_KEY}}&place_id={{PLACE_ID}}&fields=name

The result is "The provided Place ID is no longer valid" - this is just misleading error message :(
see: https://support.google.com/business/thread/120163650/the-provided-place-id-is-no-longer-valid-please-refresh-cached-place-ids-so-stuck?hl=en

So trying using the Google Business Profile API
see: https://developers.google.com/my-business/content/overview

https://mybusiness.googleapis.com/v4/accounts/102488506248101242686/locations/8026778460399333943/reviews?pageSize=1

{
    "reviews": [
      ...
    ],
    "averageRating": 5,
    "totalReviewCount": 18,
}

This can work but requires OAuth with a human user, which can't be automated.  Using a service account might work
according to https://stackoverflow.com/questions/40720692/accessing-google-my-business-api-without-login-using-service-account

Enabling DWD for the service account has security downsides and is not offically supported :(
https://stackoverflow.com/questions/66648811/google-mba-service-account-get-all-locations

...so I haven't tried the DWD approach yet


I think the next step would be just to add these as new model fields under `site_sitesettings` and add them to
the admin dashboard, so they can be manually updated each week.  We can then expose via `Query.Shop` - and move these comments to the GraphQL server code!
*/ var structuredDataAggregateReviews = function() {
    return JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        name: "The Volte Fashion Rentals",
        aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "5.0",
            reviewCount: "18"
        }
    });
};


/***/ }),

/***/ 11535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@the-volte/svc-core-sdk/lib/index.js
var lib = __webpack_require__(44859);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/providers/DatalayerProvider.tsx
var DatalayerProvider = __webpack_require__(51945);
// EXTERNAL MODULE: ./src/providers/TikTokPixelProvider.tsx + 45 modules
var TikTokPixelProvider = __webpack_require__(48841);
// EXTERNAL MODULE: ./src/components/atoms/index.ts + 6 modules
var atoms = __webpack_require__(23920);
// EXTERNAL MODULE: ./src/hooks/useLogin.ts
var useLogin = __webpack_require__(67083);
// EXTERNAL MODULE: ./src/utils/base64.ts
var base64 = __webpack_require__(43521);
// EXTERNAL MODULE: ./src/utils/facebook.ts
var facebook = __webpack_require__(74858);
// EXTERNAL MODULE: ./src/utils/getAttributeValue.ts
var getAttributeValue = __webpack_require__(6360);
;// CONCATENATED MODULE: ./src/utils/seo.ts
var extractSeoDescription = function(description) {
    // 160 chars of first block
    var result = "";
    try {
        var obj = JSON.parse(description);
        var block = obj.blocks.find(function(b) {
            return b.type === "paragraph";
        });
        // Remove space before and everything after fullstop.
        var sentance = block.data.text.replace(/^\s+|\..*$/g, "");
        result = sentance.substring(0, 159);
    // eslint-disable-next-line no-empty
    } catch (e) {}
    return result;
};

;// CONCATENATED MODULE: ./src/utils/strings.ts
/**
 * Transforms a string with the first applicable rule from an array of StringTransformRule objects.
 *
 * @param {string} text - The string to process.
 * @param {Array} rules - An array of StringTransformRule objects.
 * @return {string} The transformed string.
 */ var applyStringTransformRules = function(text, rules) {
    var result = rules.find(function(rule) {
        return rule.validate(text);
    });
    return result ? result.transform(text) : text;
};
var trimString = function(text, maxLength) {
    var end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "...";
    if (!text) return "";
    return text.length > maxLength ? "".concat(text.substring(0, maxLength).trim()).concat(end) : text;
};

// EXTERNAL MODULE: ./src/components/legacy/index.ts + 40 modules
var legacy = __webpack_require__(92291);
;// CONCATENATED MODULE: ./src/views/Product/constants.ts
var PRODUCT_PAGE_TITLE_RULES = [
    {
        validate: function(productName) {
            return productName.length > 70;
        },
        transform: function(productName) {
            return productName.slice(0, 70).trim();
        }
    },
    {
        validate: function(productName) {
            return productName.length <= 58;
        },
        transform: function(productName) {
            return productName ? "".concat(productName, " | The Volte") : "The Volte";
        }
    }, 
];

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/chakra-ui-media-query.esm.js
var chakra_ui_media_query_esm = __webpack_require__(92684);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(78420);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-media/esm/react-media.js
var react_media = __webpack_require__(87784);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(47930);
// EXTERNAL MODULE: ./src/components/molecules/index.ts + 68 modules
var molecules = __webpack_require__(27706);
// EXTERNAL MODULE: ./src/components/organisms/index.ts + 9 modules
var organisms = __webpack_require__(14254);
// EXTERNAL MODULE: ./src/components/organisms/AddToCartSection/styles.ts
var styles = __webpack_require__(60640);
// EXTERNAL MODULE: ./src/components/organisms/ProductRecommendations/index.tsx + 2 modules
var ProductRecommendations = __webpack_require__(43940);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.mjs
var md = __webpack_require__(30080);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/chakra-ui-input.esm.js
var chakra_ui_input_esm = __webpack_require__(4612);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/chakra-ui-spinner.esm.js + 1 modules
var chakra_ui_spinner_esm = __webpack_require__(89238);
;// CONCATENATED MODULE: ./src/components/organisms/SamedayPickup/LocationInput/index.tsx





var SamedayPickupLocationInput = function(param) {
    var autocompleteInputRef = param.autocompleteInputRef, errorMessage = param.errorMessage, handleUseCurrentLocation = param.handleUseCurrentLocation, loading = param.loading, reset = param.reset, setIsDrawerOpen = param.setIsDrawerOpen, distance = param.distance;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Stack */.Kq, {
        gap: "0.25rem",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_input_esm/* InputGroup */.BZ, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_input_esm/* Input */.II, {
                        ref: autocompleteInputRef,
                        disabled: loading,
                        placeholder: "Search postcode or suburb",
                        onChange: reset
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_input_esm/* InputLeftElement */.Z8, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(md/* MdSearch */.vU7, {
                            size: 24
                        })
                    }),
                    loading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_input_esm/* InputRightElement */.xH, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_spinner_esm/* Spinner */.$, {
                            size: "sm"
                        })
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                as: "span",
                color: "red",
                fontSize: "small",
                children: errorMessage
            }),
            !distance ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Stack */.Kq, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                        as: "span",
                        fontSize: "small",
                        children: "Start typing and choose a postcode or suburb from the list"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        alignItems: "center",
                        alignSelf: "center",
                        cursor: loading ? "not-allowed" : "pointer",
                        display: "flex",
                        gap: "0.5rem",
                        maxWidth: "fit-content",
                        onClick: handleUseCurrentLocation,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(md/* MdMyLocation */.x$F, {
                                    size: 20
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                    as: "span",
                                    borderBottom: "2px solid black",
                                    children: "Use my current location"
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Button, {
                onClick: function() {
                    return setIsDrawerOpen(false);
                },
                children: "Continue"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/SamedayPickup/MessageCard/index.tsx



var SamedayPickupMessageCard = function(param) {
    var isSamedayEligible = param.isSamedayEligible, distance = param.distance, canPickupToday = param.canPickupToday;
    var ref;
    var distanceMessages = [
        {
            message: "Located within approximately 5km",
            validate: function(locationDistance) {
                return locationDistance <= 5;
            }
        },
        {
            message: "Located within approximately 10km",
            validate: function(locationDistance) {
                return locationDistance > 5 && locationDistance <= 10;
            }
        },
        {
            message: "Located within approximately 15km",
            validate: function(locationDistance) {
                return locationDistance > 10 && locationDistance <= 15;
            }
        },
        {
            message: "Located within approximately 20km",
            validate: function(locationDistance) {
                return locationDistance > 15 && locationDistance <= 20;
            }
        },
        {
            message: "Located within approximately 25km",
            validate: function(locationDistance) {
                return locationDistance > 20 && locationDistance <= 25;
            }
        }, 
    ];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
        alignItems: "center",
        border: "1px solid lightgray",
        borderRadius: "0.5rem",
        boxShadow: "base",
        display: "flex",
        gap: "0.5rem",
        padding: "1rem",
        children: [
            isSamedayEligible ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(md/* MdCheckCircle */.ZSR, {
                color: "blue",
                size: 30
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(md/* MdCancel */.B4e, {
                color: "red",
                size: 30
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Stack */.Kq, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                        fontWeight: "bold",
                        style: {
                            margin: 0
                        },
                        children: !isSamedayEligible ? "Item can't be picked up" : canPickupToday ? "This item can be picked up today" : "Pickup available tomorrow"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                        fontSize: 14,
                        style: {
                            margin: 0
                        },
                        children: ((ref = distanceMessages.find(function(message) {
                            return message.validate(Number(distance));
                        })) === null || ref === void 0 ? void 0 : ref.message) || "Located approximately ".concat(distance, "km away")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/SamedayPickup/Drawer/index.tsx






var SamedayPickupDrawer = function(param) {
    var autocompleteInputRef = param.autocompleteInputRef, errorMessage = param.errorMessage, handleUseCurrentLocation = param.handleUseCurrentLocation, isDrawerOpen = param.isDrawerOpen, isSamedayEligible = param.isSamedayEligible, loading = param.loading, reset = param.reset, setIsDrawerOpen = param.setIsDrawerOpen, distance = param.distance, canPickupToday = param.canPickupToday;
    var drawerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var handleClickOutside = function(event) {
            if (drawerRef.current) {
                var rect = drawerRef.current.getBoundingClientRect();
                var isInBounds = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
                if (!isInBounds) {
                    setIsDrawerOpen(false);
                }
            }
        };
        var handleEscapeKey = function(event) {
            if (event.key === "Escape") {
                setIsDrawerOpen(false);
            }
        };
        if (isDrawerOpen) {
            document.addEventListener("mousedown", handleClickOutside);
            document.addEventListener("keydown", handleEscapeKey);
        }
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleEscapeKey);
        };
    }, [
        isDrawerOpen,
        setIsDrawerOpen,
        reset
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            isDrawerOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                height: "100vh",
                position: "fixed",
                top: 0,
                width: "100%",
                zIndex: 1000
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                backgroundColor: "white",
                boxShadow: isDrawerOpen ? "dark-lg" : "none",
                height: "100%",
                minWidth: "24rem",
                position: "fixed",
                ref: drawerRef,
                right: 0,
                top: 0,
                transform: isDrawerOpen ? "translateX(0)" : "translateX(100%)",
                transition: "transform 0.3s",
                zIndex: 1000,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                        alignItems: "center",
                        borderBottom: "2px solid black",
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "1rem",
                        position: "sticky",
                        top: "0",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                                style: {
                                    fontSize: "20px",
                                    fontWeight: 700,
                                    lineHeight: "24px"
                                },
                                children: "SET YOUR LOCATION"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(md/* MdClose */.FU5, {
                                cursor: "pointer",
                                size: 24,
                                onClick: function() {
                                    setIsDrawerOpen(false);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        padding: "1rem",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SamedayPickupLocationInput, {
                            autocompleteInputRef: autocompleteInputRef,
                            handleUseCurrentLocation: handleUseCurrentLocation,
                            loading: loading,
                            errorMessage: errorMessage,
                            reset: reset,
                            setIsDrawerOpen: setIsDrawerOpen,
                            distance: distance
                        })
                    }),
                    !loading && distance && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        margin: "0 1rem",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SamedayPickupMessageCard, {
                            isSamedayEligible: isSamedayEligible,
                            distance: distance,
                            canPickupToday: canPickupToday
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/SamedayPickup/SetLocationCard/index.tsx



var SamedayPickupSetLocationCard = function(param) {
    var setIsDrawerOpen = param.setIsDrawerOpen;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        cursor: "pointer",
        onClick: function() {
            return setIsDrawerOpen(true);
        },
        padding: "0.5rem",
        boxShadow: "base",
        border: "1px solid lightgray",
        borderRadius: "6px",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(md/* MdSearch */.vU7, {
                size: 30,
                color: "blue"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Stack */.Kq, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                        as: "span",
                        fontSize: "md",
                        style: {
                            margin: 0
                        },
                        children: "Same day pickup available"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                        as: "span",
                        fontSize: "sm",
                        fontWeight: "bold",
                        style: {
                            margin: 0
                        },
                        children: "Set your location"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/esm.js
var esm = __webpack_require__(37054);
// EXTERNAL MODULE: ./src/components/legacy/ShopProvider/context.ts
var context = __webpack_require__(61888);
// EXTERNAL MODULE: ./src/hooks/useLocalStorage.tsx
var useLocalStorage = __webpack_require__(83319);
;// CONCATENATED MODULE: ./src/components/organisms/SamedayPickup/useSamedayPickup.ts








var SAMEDAY_PICKUP_INITIAL_STATUS = {
    error: "",
    isSamedayEligible: false,
    loading: false
};
var useSamedayPickup = function(param) {
    var productWarehouseLocation = param.productWarehouseLocation, inputElement = param.inputElement;
    var isLoaded = (0,esm/* useJsApiLoader */.Ji)({
        id: "google-map-script",
        googleMapsApiKey: constants/* nextPublicGoogleMapsApiKey */.$C,
        libraries: constants/* googleMapsLibraries */.MG
    }).isLoaded;
    var ref = (0,react.useState)(), warehouseLocation = ref[0], setWarehouseLocation = ref[1];
    var ref1 = (0,react.useState)(false), isDrawerOpen = ref1[0], setIsDrawerOpen = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useLocalStorage/* useLocalStorage */._)("samedayPickupStatus", SAMEDAY_PICKUP_INITIAL_STATUS), 2), samedayPickupStatus = ref2[0], setSamedayPickupStatus = ref2[1];
    var ref3 = (0,react.useContext)(context/* ShopContext */.I), operatingHours = ref3.operatingHours, samedayOrNextdayPickupDistance = ref3.samedayOrNextdayPickupDistance;
    var geocoder = (0,react.useMemo)(function() {
        return isLoaded ? new google.maps.Geocoder() : null;
    }, [
        isLoaded
    ]);
    var canPickupToday = (0,react.useMemo)(function() {
        var ref;
        if (!(samedayPickupStatus === null || samedayPickupStatus === void 0 ? void 0 : samedayPickupStatus.isSamedayEligible)) return false;
        var today = dayjs_min_default()().format("dddd").toUpperCase();
        var currentDayOperatingHours = (ref = operatingHours === null || operatingHours === void 0 ? void 0 : operatingHours.filter(function(item) {
            return (item === null || item === void 0 ? void 0 : item.hoursType) === "SAMEDAY_PICKUP_CUTOFF";
        })) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            var ref;
            return (item === null || item === void 0 ? void 0 : (ref = item.dayOfWeek) === null || ref === void 0 ? void 0 : ref.toUpperCase()) === today;
        });
        var cutoffTime = (currentDayOperatingHours === null || currentDayOperatingHours === void 0 ? void 0 : currentDayOperatingHours.closeTime) || "22:00:00";
        var cutoffDate = dayjs_min_default()().set("hour", parseInt(cutoffTime.split(":")[0], 10)).set("minute", parseInt(cutoffTime.split(":")[1], 10)).set("second", parseInt(cutoffTime.split(":")[2], 10)).toDate();
        return dayjs_min_default()().toDate() <= dayjs_min_default()(cutoffDate).subtract(2, "hours").toDate();
    }, [
        operatingHours,
        samedayPickupStatus === null || samedayPickupStatus === void 0 ? void 0 : samedayPickupStatus.isSamedayEligible
    ]);
    (0,react.useEffect)(function() {
        if (!geocoder) return;
        geocoder.geocode({
            address: productWarehouseLocation
        }, function(results, status) {
            if (status === "OK" && (results === null || results === void 0 ? void 0 : results.length)) {
                setWarehouseLocation(results[0].geometry.location);
            }
        });
    }, [
        productWarehouseLocation,
        geocoder
    ]);
    var calculateDistance = (0,react.useCallback)(function(userLocation, warehouseGeolocation) {
        if (!google.maps.geometry.spherical) {
            setSamedayPickupStatus({
                error: "Failed to load geometry. Please try again.",
                isSamedayEligible: false,
                loading: false
            });
            return;
        }
        var distanceInKm = google.maps.geometry.spherical.computeDistanceBetween(userLocation, warehouseGeolocation) / 1000;
        var roundUpToNearest100 = function(distance) {
            return Math.ceil(distance / 100) * 100;
        };
        setSamedayPickupStatus({
            error: isNaN(distanceInKm) ? "Failed to calculate distance. Please try again." : "",
            isSamedayEligible: distanceInKm <= Number(samedayOrNextdayPickupDistance || "25"),
            loading: false,
            distance: distanceInKm <= 100 ? distanceInKm.toFixed(0) : roundUpToNearest100(distanceInKm).toString(),
            userLocation: userLocation
        });
    }, []);
    (0,react.useEffect)(function() {
        var userLocation = samedayPickupStatus === null || samedayPickupStatus === void 0 ? void 0 : samedayPickupStatus.userLocation;
        if (warehouseLocation && userLocation) {
            calculateDistance(userLocation, warehouseLocation);
        }
    }, [
        calculateDistance,
        warehouseLocation
    ]);
    var handlePlaceChanged = (0,react.useCallback)(function() {
        if (!inputElement) return;
        var autocomplete = new google.maps.places.Autocomplete(inputElement, {
            types: [
                "geocode"
            ],
            componentRestrictions: {
                country: "au"
            }
        });
        var placeChangedListener = function() {
            var ref, ref1;
            // setSamedayPickupStatus((prev) => ({ ...prev, loading: true }));
            setSamedayPickupStatus({
                error: "",
                isSamedayEligible: false,
                loading: true
            });
            var userLocation = (ref = autocomplete.getPlace()) === null || ref === void 0 ? void 0 : (ref1 = ref.geometry) === null || ref1 === void 0 ? void 0 : ref1.location;
            if (userLocation && warehouseLocation) {
                calculateDistance(userLocation, warehouseLocation);
            } else {
                setSamedayPickupStatus({
                    error: "Unable to find your location. Please try again.",
                    isSamedayEligible: false,
                    loading: false
                });
            }
        };
        autocomplete.addListener("place_changed", placeChangedListener);
        return function() {
            return google.maps.event.clearInstanceListeners(autocomplete);
        };
    }, [
        inputElement,
        warehouseLocation,
        calculateDistance
    ]);
    (0,react.useEffect)(function() {
        return handlePlaceChanged();
    }, [
        handlePlaceChanged
    ]);
    var handleUseCurrentLocation = (0,react.useCallback)(function() {
        if (!geocoder) return;
        // setSamedayPickupStatus((prev) => ({ ...prev, loading: true }));
        setSamedayPickupStatus({
            error: "",
            isSamedayEligible: false,
            loading: true
        });
        if (!navigator.geolocation) {
            setSamedayPickupStatus({
                error: "Geolocation is not supported by this browser.",
                isSamedayEligible: false,
                loading: false
            });
            return;
        }
        var onGeolocationSuccess = function(position) {
            var userLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
            if (!warehouseLocation) {
                // setSamedayPickupStatus((prev) => ({ ...prev, loading: false }));
                setSamedayPickupStatus({
                    error: "",
                    isSamedayEligible: false,
                    loading: false
                });
                return;
            }
            geocoder.geocode({
                location: userLocation
            }, function(results, status) {
                if (status === "OK" && (results === null || results === void 0 ? void 0 : results.length) && inputElement) {
                    inputElement.value = results[0].formatted_address;
                    calculateDistance(userLocation, warehouseLocation);
                } else {
                    setSamedayPickupStatus({
                        error: "Failed to retrieve your current address. Please try again.",
                        isSamedayEligible: false,
                        loading: false
                    });
                }
            });
        };
        var onGeolocationError = function(error) {
            var _obj;
            var errorMessages = (_obj = {}, (0,_define_property/* default */.Z)(_obj, error.PERMISSION_DENIED, "Request for Geolocation was denied."), (0,_define_property/* default */.Z)(_obj, error.POSITION_UNAVAILABLE, "Location information is unavailable."), (0,_define_property/* default */.Z)(_obj, error.TIMEOUT, "Request to get the location timed out. Please try again."), _obj);
            setSamedayPickupStatus({
                error: errorMessages[error.code] || "An unknown error occurred.",
                isSamedayEligible: false,
                loading: false
            });
        };
        navigator.geolocation.getCurrentPosition(onGeolocationSuccess, onGeolocationError, {
            timeout: 5000
        });
    }, [
        warehouseLocation,
        inputElement,
        calculateDistance,
        geocoder
    ]);
    var reset = function() {
        setSamedayPickupStatus(SAMEDAY_PICKUP_INITIAL_STATUS);
    };
    return {
        canPickupToday: canPickupToday,
        distance: (samedayPickupStatus === null || samedayPickupStatus === void 0 ? void 0 : samedayPickupStatus.distance) || "",
        errorMessage: (samedayPickupStatus === null || samedayPickupStatus === void 0 ? void 0 : samedayPickupStatus.error) || "",
        handleUseCurrentLocation: handleUseCurrentLocation,
        isSamedayEligible: (samedayPickupStatus === null || samedayPickupStatus === void 0 ? void 0 : samedayPickupStatus.isSamedayEligible) || false,
        isDrawerOpen: isDrawerOpen,
        loading: (samedayPickupStatus === null || samedayPickupStatus === void 0 ? void 0 : samedayPickupStatus.loading) || false,
        reset: reset,
        setIsDrawerOpen: setIsDrawerOpen,
        isLoaded: isLoaded
    };
};

// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
// EXTERNAL MODULE: ./src/globalStyles/index.ts + 2 modules
var globalStyles = __webpack_require__(63319);
// EXTERNAL MODULE: ./src/globalStyles/constants.ts
var globalStyles_constants = __webpack_require__(71467);
// EXTERNAL MODULE: ./src/core/SEO/Product/structuredData.tsx
var structuredData = __webpack_require__(97712);
// EXTERNAL MODULE: ./src/globalStyles/variables.ts
var variables = __webpack_require__(12864);
// EXTERNAL MODULE: ./node_modules/embla-carousel-react/embla-carousel-react.esm.js + 1 modules
var embla_carousel_react_esm = __webpack_require__(57434);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/molecules/WishlistButton/WishlistButton.tsx + 3 modules
var WishlistButton = __webpack_require__(74041);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./src/views/Product/GalleryCarousel/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n\n  .embla__viewport {\n    overflow: hidden;\n    width: 100%;\n  }\n\n  .embla__viewport.is-draggable {\n    cursor: move;\n    cursor: grab;\n  }\n\n  .embla__viewport.is-dragging {\n    cursor: grabbing;\n  }\n\n  .embla__container {\n    display: flex;\n    user-select: none;\n    -webkit-touch-callout: none;\n    -khtml-user-select: none;\n    -webkit-tap-highlight-color: transparent;\n    margin-left: -10px;\n  }\n\n  .embla__slide {\n    position: relative;\n    min-width: 100%;\n    padding-left: 10px;\n  }\n\n  .embla__slide__inner {\n    display: block;\n    position: relative;\n    overflow: hidden;\n    min-height: 490px;\n    max-height: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 12px;\n  left: 0;\n  right: 0;\n  text-align: center;\n  margin-left: auto;\n  margin-right: auto;\n  list-style: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var EmblaWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject());
var Embla = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1());
var EmblaDots = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2());

;// CONCATENATED MODULE: ./src/views/Product/GalleryCarousel/index.tsx









var GalleryCarousel = function(param) {
    var images = param.images, _handleChange = param.handleChange, handleChange = _handleChange === void 0 ? function() {} : _handleChange, _imageFit = param.imageFit, imageFit = _imageFit === void 0 ? "contain" : _imageFit, toggleWishlist = param.toggleWishlist, isInWishlist = param.isInWishlist;
    var ref = (0,_sliced_to_array/* default */.Z)((0,embla_carousel_react_esm/* default */.Z)({
        skipSnaps: false,
        loop: true
    }), 2), viewportRef = ref[0], embla = ref[1];
    var ref1 = (0,react.useState)(0), selectedIndex = ref1[0], setSelectedIndex = ref1[1];
    var ref2 = (0,react.useState)([]), scrollSnaps = ref2[0], setScrollSnaps = ref2[1];
    var scrollTo = (0,react.useCallback)(function(index) {
        return embla && embla.scrollTo(index);
    }, [
        embla
    ]);
    var handleClickDotButton = function(e, index) {
        e.stopPropagation();
        scrollTo(index);
    };
    var onSelect = (0,react.useCallback)(function() {
        if (!embla) return;
        setSelectedIndex(embla.selectedScrollSnap());
        handleChange(embla.selectedScrollSnap());
    }, [
        embla,
        setSelectedIndex
    ]);
    (0,react.useEffect)(function() {
        if (!embla) return;
        onSelect();
        setScrollSnaps(embla.scrollSnapList());
        embla.on("select", onSelect);
    }, [
        embla,
        setScrollSnaps,
        onSelect
    ]);
    var imageLoader = function(param) {
        var src = param.src, width = param.width, quality = param.quality;
        var path = new URL(src).pathname;
        return "".concat(constants/* imageLoaderUri */.EP, "/_next/image/?url=").concat(path, "&w=").concat(width || 550, "&q=").concat(quality || 75);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EmblaWrapper, {
        children: [
            !!toggleWishlist && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WishlistButton/* default */.Z, {
                toggleWishlist: toggleWishlist,
                isInWishlist: isInWishlist
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Embla, {
                imageFit: imageFit,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "embla__viewport",
                    ref: viewportRef,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "embla__container",
                        children: !!images && images.map(function(image) {
                            if (!image) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
                            }
                            var id = image.id, url = image.url, mobileUrl = image.mobileUrl, alt = image.alt;
                            // const firstImage = index === 0;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                className: "embla__slide",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    className: "embla__slide__inner",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                        // NOTES img element has fetchPriority prop, but currently on our version of nextjs it is not defined in the types. fetchPriority was added on Next.js 13.3.0 https://github.com/vercel/next.js/discussions/39740#discussioncomment-6853256
                                        // @ts-expect-error
                                        fetchPriority: "high",
                                        priority: true,
                                        src: mobileUrl || url,
                                        loader: imageLoader,
                                        layout: "fill",
                                        alt: alt || "product_#".concat(id),
                                        objectFit: "contain"
                                    })
                                })
                            }, id);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmblaDots, {
                children: scrollSnaps.map(function(_, index) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.CarouselButtons, {
                        selected: index === selectedIndex,
                        onClick: function(e) {
                            return handleClickDotButton(e, index);
                        }
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var Product_GalleryCarousel = (GalleryCarousel);

// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 6 modules
var graphql_tag_lib = __webpack_require__(22841);
// EXTERNAL MODULE: ./src/views/queries.ts
var queries = __webpack_require__(78676);
// EXTERNAL MODULE: ./src/graphql/fragments.ts
var fragments = __webpack_require__(7905);
// EXTERNAL MODULE: ./src/graphql/queries.ts
var graphql_queries = __webpack_require__(23149);
;// CONCATENATED MODULE: ./src/views/Product/queries.ts

function queries_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  query SimilarProductList($similarProductId: ID) {\n    products(\n      first: 8\n      similarProductId: $similarProductId\n      # NOTES channel is hardcoded since we are not using the 'channel' DB table\n      filter: { stockAvailability: IN_STOCK, channel: \"default-channel\" }\n    ) {\n      edges {\n        node {\n          ...BasicProductFields\n          ...ProductPricingFieldSF\n          ...ShippingMethods\n        }\n      }\n      totalCount\n    }\n  }\n"
    ]);
    queries_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function queries_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ResourceQuery($slug: String!, $channel: String!, $public: Boolean!) {\n    product(slug: $slug, channel: $channel, public: $public) {\n      id\n      slug\n      purchaseStatus\n      resource {\n        id\n        preparationDays\n        bookings {\n          dates {\n            date\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    queries_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var similarProductList = (0,graphql_tag_lib["default"])(queries_templateObject(), fragments/* basicProductFragment */.kf, fragments/* productPricingFragment */.XA, fragments/* shippingMethodsFragment */.v6);
var useSimilarProductsQuery = function(data, unavailable) {
    if (!data) {
        return {
            data: {
                products: {
                    edges: []
                }
            }
        };
    }
    var variables;
    if (unavailable) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var sizeAttribute = data === null || data === void 0 ? void 0 : (ref = data.attributes) === null || ref === void 0 ? void 0 : ref.find(function(attr) {
            return attr.attribute.name === "Size";
        });
        var size = (sizeAttribute === null || sizeAttribute === void 0 ? void 0 : (ref1 = sizeAttribute.values) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.name) || "Not Found";
        var styleAttribute = data === null || data === void 0 ? void 0 : (ref3 = data.attributes) === null || ref3 === void 0 ? void 0 : ref3.find(function(attr) {
            return attr.attribute.name === "Item Style";
        });
        var productStyles = (styleAttribute === null || styleAttribute === void 0 ? void 0 : (ref4 = styleAttribute.values) === null || ref4 === void 0 ? void 0 : ref4.map(function(value) {
            var ref;
            return (value === null || value === void 0 ? void 0 : (ref = value.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "";
        })) || [];
        variables = {
            first: 4,
            filterIsb: true,
            attributes: {
                size: [
                    size
                ],
                "item-style": productStyles
            },
            channel: constants/* channelSlug */.m_,
            categoryId: data === null || data === void 0 ? void 0 : (ref5 = data.category) === null || ref5 === void 0 ? void 0 : ref5.id,
            similarProductId: data === null || data === void 0 ? void 0 : data.id
        };
    } else {
        variables = {
            first: constants/* productsPerPage */.ct,
            public: true,
            similarProductId: data === null || data === void 0 ? void 0 : data.id
        };
    }
    return (0,graphql_queries/* useTypedQuery */.OK)(unavailable ? queries/* productList */.U : similarProductList, {
        variables: variables,
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first"
    });
};
var useLenderProductsQuery = function(slug) {
    var variables = {
        channel: "default-channel",
        lenderSlug: slug
    };
    return (0,graphql_queries/* useTypedQuery */.OK)(graphql_queries/* lenderProductsQuery */.CY, {
        variables: variables,
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first"
    });
};
var productResourceBookingQuery = (0,graphql_tag_lib["default"])(queries_templateObject1());
var useProductResourceBooking = function(slug) {
    var variables = {
        slug: slug,
        channel: constants/* channelSlug */.m_,
        public: true
    };
    return (0,graphql_queries/* useTypedQuery */.OK)(productResourceBookingQuery, {
        variables: variables,
        fetchPolicy: "no-cache"
    });
};

;// CONCATENATED MODULE: ./src/views/Product/Page.tsx

































var populateBreadcrumbs = function(product) {
    var ref, ref1, ref2;
    return [
        {
            link: (0,react_router/* generatePath */.Gn)((product === null || product === void 0 ? void 0 : (ref = product.category) === null || ref === void 0 ? void 0 : ref.slug) === "dresses" ? paths/* paths.dresses */.H.dresses : paths/* paths.category */.H.category, {
                slug: product === null || product === void 0 ? void 0 : (ref1 = product.category) === null || ref1 === void 0 ? void 0 : ref1.slug
            }),
            value: (product === null || product === void 0 ? void 0 : (ref2 = product.category) === null || ref2 === void 0 ? void 0 : ref2.name) || ""
        },
        {
            link: (0,react_router/* generatePath */.Gn)(paths/* paths.product */.H.product, {
                slug: product === null || product === void 0 ? void 0 : product.slug
            }),
            value: (product === null || product === void 0 ? void 0 : product.name) || ""
        }, 
    ];
};
var InfoBox = function(param) {
    var children = param.children, fixed = param.fixed;
    var fixedStyling = fixed ? {
        top: 0,
        position: "sticky",
        width: {
            base: "auto",
            lg: "calc(".concat(globalStyles/* defaultTheme.sizes.container.lg */.uH.sizes.container.lg, " * 30 / 100)")
        }
    } : {};
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        flexGrow: 1,
        position: "relative",
        width: {
            base: "100%",
            lg: "50%"
        },
        paddingLeft: {
            lg: fixed ? 0 : "60px"
        }
    }, fixedStyling), {
        children: children
    }));
};
var Page = function(param) {
    var add = param.add, product = param.product, items = param.items, onAttributeChangeHandler = param.onAttributeChangeHandler, editLink = param.editLink, user = param.user, toggleWishlist = param.toggleWishlist, isInWishlist = param.isInWishlist, removeItem = param.removeItem, _loaded = param.loaded, loaded = _loaded === void 0 ? false : _loaded, showRecommendations = param.showRecommendations;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
    var ref19 = (0,react.useState)(false), clientFetchBookings = ref19[0], setClientFetchBookings = ref19[1];
    var ref20 = (0,next_router.useRouter)(), push = ref20.push, query = ref20.query;
    var ref21 = (0,_sliced_to_array/* default */.Z)((0,chakra_ui_media_query_esm/* useMediaQuery */.ac)("(max-width: ".concat(globalStyles_constants/* breakpoints.md */.AV.md, ")")), 1), isMobile = ref21[0];
    var productGalleryRef = react.useRef();
    var data = useSimilarProductsQuery(product, showRecommendations).data;
    var ref22 = useProductResourceBooking(typeof query.slug === "string" ? query.slug : ""), productBookingsData = ref22.data, productBookingsLoading = ref22.loading, refetchProductBookings = ref22.refetch;
    var initialProductBookings = product === null || product === void 0 ? void 0 : product.resource;
    var clientProductBookings = productBookingsData === null || productBookingsData === void 0 ? void 0 : (ref = productBookingsData.product) === null || ref === void 0 ? void 0 : ref.resource;
    var bookingsToUse = productBookingsLoading && !clientFetchBookings ? {
        type: "ssr",
        data: initialProductBookings
    } : {
        type: "client",
        data: clientProductBookings
    };
    var bookedDates = react.useMemo(function() {
        var ref, ref1;
        return (bookingsToUse === null || bookingsToUse === void 0 ? void 0 : (ref = bookingsToUse.data) === null || ref === void 0 ? void 0 : (ref1 = ref.bookings) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(acc1, booking) {
            var ref;
            return (0,_to_consumable_array/* default */.Z)(acc1).concat((0,_to_consumable_array/* default */.Z)((booking === null || booking === void 0 ? void 0 : (ref = booking.dates) === null || ref === void 0 ? void 0 : ref.reduce(function(acc2, acc3) {
                return (0,_to_consumable_array/* default */.Z)(acc2).concat([
                    (0,parseISO/* default */.Z)(acc3 === null || acc3 === void 0 ? void 0 : acc3.date)
                ]);
            }, [])) || []));
        }, [])) || [];
    }, [
        bookingsToUse === null || bookingsToUse === void 0 ? void 0 : (ref1 = bookingsToUse.data) === null || ref1 === void 0 ? void 0 : ref1.bookings
    ]);
    var lenderProductsData = useLenderProductsQuery((product === null || product === void 0 ? void 0 : (ref2 = product.lender) === null || ref2 === void 0 ? void 0 : ref2.slug) || "");
    var numberOfProducts = ((ref3 = lenderProductsData.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.products) === null || ref4 === void 0 ? void 0 : ref4.totalCount) || 0;
    var ref23 = (0,_sliced_to_array/* default */.Z)(react.useState((product === null || product === void 0 ? void 0 : (ref5 = product.defaultVariant) === null || ref5 === void 0 ? void 0 : ref5.id) || ""), 2), variantId = ref23[0], setVariantId = ref23[1];
    (0,react.useEffect)(function() {
        var ref;
        setVariantId((product === null || product === void 0 ? void 0 : (ref = product.defaultVariant) === null || ref === void 0 ? void 0 : ref.id) || "");
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var images = react.useMemo(function() {
        if ((product === null || product === void 0 ? void 0 : product.variants) && variantId) {
            var variant = product.variants.find(function(v) {
                return (v === null || v === void 0 ? void 0 : v.id) === variantId;
            });
            if ((variant === null || variant === void 0 ? void 0 : variant.images) && variant.images.length > 0) {
                return variant === null || variant === void 0 ? void 0 : variant.images;
            }
        }
        return product === null || product === void 0 ? void 0 : product.images;
    }, [
        product === null || product === void 0 ? void 0 : product.variants,
        variantId
    ]);
    var autocompleteInputRef = (0,react.useRef)(null);
    var ref24 = useSamedayPickup({
        productWarehouseLocation: (product === null || product === void 0 ? void 0 : product.location) || "",
        inputElement: autocompleteInputRef.current
    }), canPickupToday = ref24.canPickupToday, distance = ref24.distance, errorMessage = ref24.errorMessage, handleUseCurrentLocation = ref24.handleUseCurrentLocation, isDrawerOpen = ref24.isDrawerOpen, isSamedayEligible = ref24.isSamedayEligible, loading = ref24.loading, reset = ref24.reset, setIsDrawerOpen = ref24.setIsDrawerOpen, isLoaded = ref24.isLoaded;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(params) {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                add((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                    resourceId: product === null || product === void 0 ? void 0 : (ref = product.resource) === null || ref === void 0 ? void 0 : ref.id,
                    isSamedayEligible: isSamedayEligible && isSamedayOrNextdayValid
                }));
                // If user is not logged in then redirect to login before proceeding to checkout
                push(user ? paths/* paths.checkout */.H.checkout : paths/* paths.login */.H.login);
                return [
                    2
                ];
            });
        });
        return function onSubmit(params) {
            return _ref.apply(this, arguments);
        };
    }();
    var hasPurchaseVariant = product === null || product === void 0 ? void 0 : (ref6 = product.variants) === null || ref6 === void 0 ? void 0 : ref6.find(function(productVariant) {
        return (productVariant === null || productVariant === void 0 ? void 0 : productVariant.name) === "Purchase";
    });
    var isPurchaseType = (query === null || query === void 0 ? void 0 : query.price) === "purchase" && !(0,lodash.isEmpty)(hasPurchaseVariant);
    var isAvailableForRent = (product === null || product === void 0 ? void 0 : (ref7 = product.variants) === null || ref7 === void 0 ? void 0 : ref7.length) !== 0;
    var removeToCartHandler = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(productVariantId) {
            var removeItemReq;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            removeItem(productVariantId)
                        ];
                    case 1:
                        removeItemReq = _state.sent();
                        return [
                            4,
                            refetchProductBookings()
                        ];
                    case 2:
                        _state.sent();
                        setClientFetchBookings(true);
                        return [
                            2,
                            removeItemReq
                        ];
                }
            });
        });
        return function removeToCartHandler(productVariantId) {
            return _ref.apply(this, arguments);
        };
    }();
    var designer = (ref9 = product === null || product === void 0 ? void 0 : (ref8 = product.attributes) === null || ref8 === void 0 ? void 0 : ref8.find(function(attr) {
        return attr.attribute.name === "Designer";
    })) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.values) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : ref11.name;
    var designerSlug = (ref13 = product === null || product === void 0 ? void 0 : (ref12 = product.attributes) === null || ref12 === void 0 ? void 0 : ref12.find(function(attr) {
        return attr.attribute.name === "Designer";
    })) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.values) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[0]) === null || ref15 === void 0 ? void 0 : ref15.slug;
    var rentalDays = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref.find(function(pv) {
            return (pv === null || pv === void 0 ? void 0 : pv.id) === variantId;
        })) === null || ref1 === void 0 ? void 0 : ref1.rentalDays;
    }, [
        product === null || product === void 0 ? void 0 : product.variants,
        variantId
    ]);
    var isSamedayOrNextdayValid = (0,react.useMemo)(function() {
        if (!bookedDates) return true;
        var today = dayjs_min_default()().startOf("day");
        var tomorrow = dayjs_min_default()().add(1, "day").startOf("day");
        var bookedDatesSet = new Set(bookedDates.map(function(date) {
            return dayjs_min_default()(date).startOf("day").toDate().toLocaleDateString();
        }));
        var areDaysAvailable = function(startDate) {
            var ref;
            var preparationDays = (product === null || product === void 0 ? void 0 : (ref = product.resource) === null || ref === void 0 ? void 0 : ref.preparationDays) || 0;
            var datesToCheck = Array.from({
                length: (rentalDays || 4) + preparationDays
            }, function(_, index) {
                return startDate.add(index, "day").toDate().toLocaleDateString();
            });
            return datesToCheck.every(function(date) {
                return !bookedDatesSet.has(date);
            });
        };
        if (canPickupToday) {
            // Check if the product is available for rent for 4 days starting today
            return areDaysAvailable(today);
        }
        // Check if the product is available for rent for 4 days starting tomorrow
        return areDaysAvailable(tomorrow);
    }, [
        bookedDates,
        canPickupToday,
        items,
        rentalDays
    ]);
    var shouldDisplaySamedayPickup = (0,react.useMemo)(function() {
        var ref;
        var samedayPickupEnabled = product === null || product === void 0 ? void 0 : (ref = product.shippingMethods) === null || ref === void 0 ? void 0 : ref.find(function(method) {
            var ref, ref1;
            return (ref1 = method === null || method === void 0 ? void 0 : (ref = method.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.includes("same day");
        });
        // Same day pickup will only be displayed when
        // lender has enabled same day or next day pickup in his/her warehouse,
        // and if the product is not yet booked today or tomorrow
        return !!(product === null || product === void 0 ? void 0 : product.location) && !!samedayPickupEnabled && isSamedayOrNextdayValid;
    }, [
        isSamedayOrNextdayValid,
        product
    ]);
    var addToCartSection = function(param) {
        var mobile = param.mobile;
        return isPurchaseType ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* AddToCartSectionDesignB */.Gu, {
            items: items,
            bookedDates: bookedDates,
            name: (product === null || product === void 0 ? void 0 : product.name) || "",
            designer: designer || "",
            designerSlug: designerSlug || "",
            product: product,
            productVariants: product === null || product === void 0 ? void 0 : product.variants,
            productPricing: product === null || product === void 0 ? void 0 : product.pricing,
            productSeoDescription: product === null || product === void 0 ? void 0 : product.seoDescription,
            productAttributes: product === null || product === void 0 ? void 0 : product.attributes,
            setVariantId: setVariantId,
            variantId: variantId,
            onSubmit: onSubmit,
            onAttributeChangeHandler: onAttributeChangeHandler,
            isAvailableForPurchase: product === null || product === void 0 ? void 0 : product.isAvailableForPurchase,
            availableForPurchase: product === null || product === void 0 ? void 0 : product.availableForPurchase,
            mobile: mobile,
            removeItem: removeToCartHandler,
            productBookingsLoading: clientFetchBookings && productBookingsLoading,
            loaded: loaded,
            isSamedayEligible: isSamedayEligible && shouldDisplaySamedayPickup,
            canPickupToday: canPickupToday
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* AddToCartSection */.HY, {
            items: items,
            bookedDates: bookedDates,
            name: (product === null || product === void 0 ? void 0 : product.name) || "",
            designer: designer || "",
            designerSlug: designerSlug || "",
            product: product,
            productVariants: product === null || product === void 0 ? void 0 : product.variants,
            productPricing: product === null || product === void 0 ? void 0 : product.pricing,
            productSeoDescription: product === null || product === void 0 ? void 0 : product.seoDescription,
            productAttributes: product === null || product === void 0 ? void 0 : product.attributes,
            setVariantId: setVariantId,
            variantId: variantId,
            onSubmit: onSubmit,
            onAttributeChangeHandler: onAttributeChangeHandler,
            isAvailableForPurchase: product === null || product === void 0 ? void 0 : product.isAvailableForPurchase,
            availableForPurchase: product === null || product === void 0 ? void 0 : product.availableForPurchase,
            mobile: mobile,
            removeItem: removeToCartHandler,
            productBookingsLoading: clientFetchBookings && productBookingsLoading,
            loaded: loaded,
            isAvailableForRent: isAvailableForRent,
            isSamedayEligible: isSamedayEligible && shouldDisplaySamedayPickup,
            canPickupToday: canPickupToday
        });
    };
    var size = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        var sizeAttribute = product === null || product === void 0 ? void 0 : (ref = product.attributes) === null || ref === void 0 ? void 0 : ref.find(function(attr) {
            return attr.attribute.name === "Size";
        });
        var productSize = (sizeAttribute === null || sizeAttribute === void 0 ? void 0 : (ref1 = sizeAttribute.values) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.name) || "Not Found";
        return productSize;
    }, [
        product
    ]);
    (0,react.useEffect)(function() {
        refetchProductBookings();
    }, [
        items
    ]);
    var handleChangeLocation = function() {
        if (autocompleteInputRef.current) {
            autocompleteInputRef.current.value = "";
        }
        reset();
        setIsDrawerOpen(true);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            (product === null || product === void 0 ? void 0 : product.location) && (product === null || product === void 0 ? void 0 : product.slug) && isLoaded && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SamedayPickupDrawer, {
                autocompleteInputRef: autocompleteInputRef,
                errorMessage: errorMessage,
                handleUseCurrentLocation: handleUseCurrentLocation,
                isDrawerOpen: isDrawerOpen,
                isSamedayEligible: isSamedayEligible,
                loading: loading,
                reset: reset,
                setIsDrawerOpen: setIsDrawerOpen,
                distance: distance,
                canPickupToday: canPickupToday
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                backgroundColor: globalStyles/* defaultTheme.colors.white */.uH.colors.white,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy.Breadcrumbs, {
                            breadcrumbs: populateBreadcrumbs(product)
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        display: "flex",
                        marginTop: "1rem",
                        marginBottom: {
                            base: "2rem",
                            lg: "50px"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                            py: 0,
                            px: [
                                0,
                                null,
                                null,
                                "12px"
                            ],
                            width: "100%",
                            maxWidth: {
                                base: "100vw",
                                lg: globalStyles/* defaultTheme.sizes.container.lg */.uH.sizes.container.lg
                            },
                            paddingLeft: "0.625rem",
                            paddingRight: "0.625rem",
                            margin: {
                                lg: "0 auto"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                        name: "robots",
                                        content: "max-image-preview:large"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                                    className: "structured-data-list",
                                    type: "application/ld+json",
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML: {
                                        __html: (0,structuredData/* structuredData */.n)(product)
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_media/* default */.Z, {
                                    query: {
                                        maxWidth: variables/* mediumScreen */.M7
                                    },
                                    children: function(matches) {
                                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                                        return matches ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                                            flexDirection: "column",
                                            children: [
                                                editLink,
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Product_GalleryCarousel, {
                                                    images: images,
                                                    toggleWishlist: toggleWishlist,
                                                    isInWishlist: isInWishlist
                                                }),
                                                !(product === null || product === void 0 ? void 0 : product.isDeleted) && !showRecommendations && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                                                    marginTop: "1rem",
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoBox, {
                                                            children: addToCartSection({
                                                                mobile: true
                                                            })
                                                        }),
                                                        shouldDisplaySamedayPickup && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                            children: !distance ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SamedayPickupSetLocationCard, {
                                                                setIsDrawerOpen: setIsDrawerOpen
                                                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Stack */.Kq, {
                                                                gap: "0.5rem",
                                                                style: {
                                                                    margin: 0,
                                                                    padding: 0
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SamedayPickupMessageCard, {
                                                                        isSamedayEligible: isSamedayEligible,
                                                                        distance: distance,
                                                                        canPickupToday: canPickupToday
                                                                    }),
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Button, {
                                                                        onClick: handleChangeLocation,
                                                                        children: "Change my location"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                showRecommendations && (data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : (ref1 = ref.edges) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                                                    flex: 1,
                                                    marginTop: "1rem",
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* ProductNameHeader */.ox, {
                                                            "data-test": "productName",
                                                            children: product === null || product === void 0 ? void 0 : product.name
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* ProductSizeHeader */.vH, {
                                                            "data-test": "productSize",
                                                            children: "Size ".concat(size)
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductRecommendations/* ProductRecommendations */.T, {
                                                            recommendations: data.products.edges,
                                                            category: product === null || product === void 0 ? void 0 : (ref2 = product.category) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.name) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                                            sx: {
                                                gap: showRecommendations ? "1.5rem" : ""
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                                    className: "gallery",
                                                    ref: productGalleryRef,
                                                    flexGrow: 2,
                                                    padding: "0",
                                                    boxSizing: "border-box",
                                                    width: "100%",
                                                    flex: showRecommendations ? 1.5 : "",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* ProductGallery */.YP, {
                                                        images: images,
                                                        editLink: editLink,
                                                        toggleWishlist: toggleWishlist,
                                                        isInWishlist: isInWishlist
                                                    })
                                                }),
                                                !(product === null || product === void 0 ? void 0 : product.isDeleted) && !showRecommendations && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Stack */.Kq, {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoBox, {
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoBox, {
                                                            fixed: true,
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Stack */.Kq, {
                                                                gap: "1rem",
                                                                children: [
                                                                    addToCartSection({
                                                                        mobile: false
                                                                    }),
                                                                    shouldDisplaySamedayPickup && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                                        children: !distance ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SamedayPickupSetLocationCard, {
                                                                            setIsDrawerOpen: setIsDrawerOpen
                                                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Stack */.Kq, {
                                                                            gap: "0.5rem",
                                                                            style: {
                                                                                margin: 0,
                                                                                padding: 0
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SamedayPickupMessageCard, {
                                                                                    isSamedayEligible: isSamedayEligible,
                                                                                    distance: distance,
                                                                                    canPickupToday: canPickupToday
                                                                                }),
                                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Button, {
                                                                                    onClick: handleChangeLocation,
                                                                                    children: "Change my location"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }),
                                                showRecommendations && (data === null || data === void 0 ? void 0 : (ref4 = data.products) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.edges) === null || ref5 === void 0 ? void 0 : ref5.length) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                                                    flex: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* ProductNameHeader */.ox, {
                                                            "data-test": "productName",
                                                            children: product === null || product === void 0 ? void 0 : product.name
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* ProductSizeHeader */.vH, {
                                                            "data-test": "productSize",
                                                            children: "Size ".concat(size)
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductRecommendations/* ProductRecommendations */.T, {
                                                            recommendations: data.products.edges,
                                                            category: product === null || product === void 0 ? void 0 : (ref6 = product.category) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.name) === null || ref7 === void 0 ? void 0 : ref7.toLowerCase()
                                                        })
                                                    ]
                                                })
                                            ]
                                        });
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                            width: "100%",
                            minHeight: "10rem",
                            children: product && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(molecules/* ProductDescription */.vI, {
                                description: product.description,
                                attributes: product.attributes,
                                categorySlug: (ref16 = product.category) === null || ref16 === void 0 ? void 0 : ref16.slug,
                                product: product
                            })
                        })
                    }),
                    !!(product === null || product === void 0 ? void 0 : product.lender) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(molecules/* ProductLender */.$x, {
                        lender: product.lender,
                        numberOfProducts: numberOfProducts
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        padding: isMobile ? "0 0.93rem" : "0 8rem",
                        marginBottom: showRecommendations ? "3rem" : "",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* ContactDetails */.mv, {})
                    }),
                    (data === null || data === void 0 ? void 0 : (ref17 = data.products) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.edges) === null || ref18 === void 0 ? void 0 : ref18.length) && !showRecommendations && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(molecules/* ProductYMAL */.ov, {
                        products: data.products.edges
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Product_Page = (Page);

;// CONCATENATED MODULE: ./src/views/Product/ProductPage.tsx























var canDisplay = function(product) {
    return !!(product === null || product === void 0 ? void 0 : product.name) && !!(product === null || product === void 0 ? void 0 : product.pricing) && !!(product === null || product === void 0 ? void 0 : product.variants);
};
var extractMeta = function(product, canonicalUrl) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    return {
        custom: [
            {
                content: product === null || product === void 0 ? void 0 : (ref = product.pricing) === null || ref === void 0 ? void 0 : (ref1 = ref.priceRange) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.start) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.gross) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.amount) === null || ref4 === void 0 ? void 0 : ref4.toString(),
                property: "product:price:amount"
            },
            {
                content: product === null || product === void 0 ? void 0 : (ref5 = product.pricing) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.priceRange) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.start) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.gross) === null || ref8 === void 0 ? void 0 : ref8.currency,
                property: "product:price:currency"
            },
            {
                content: (product === null || product === void 0 ? void 0 : product.isAvailable) ? "in stock" : "out off stock",
                property: "product:isAvailable"
            },
            {
                content: product === null || product === void 0 ? void 0 : (ref9 = product.category) === null || ref9 === void 0 ? void 0 : ref9.name,
                property: "product:category"
            }, 
        ],
        description: (product === null || product === void 0 ? void 0 : product.seoDescription) || extractSeoDescription(product === null || product === void 0 ? void 0 : product.description),
        lender: product === null || product === void 0 ? void 0 : product.lender,
        image: product === null || product === void 0 ? void 0 : (ref10 = product.thumbnail2x) === null || ref10 === void 0 ? void 0 : ref10.url,
        title: applyStringTransformRules((product === null || product === void 0 ? void 0 : (ref11 = product.name) === null || ref11 === void 0 ? void 0 : ref11.trim()) || "", PRODUCT_PAGE_TITLE_RULES),
        type: "product.item",
        url: constants/* ssrMode */.$m ? __webpack_require__.g.location.href : window.location.href,
        canonicalUrl: canonicalUrl
    };
};
// Component for rendering our Product Display
var PageWithQueryAttributes = function(props) {
    var ref = (0,next_router.useRouter)(), pathname = ref.pathname, push = ref.push, query = ref.query, asPath = ref.asPath;
    var onAttributeChangeHandler = function(slug, value) {
        if (slug) {
            var newAsPath = query_string.stringifyUrl({
                query: (0,_define_property/* default */.Z)({}, slug, value),
                url: asPath
            }, {
                skipNull: true
            });
            push({
                pathname: pathname,
                query: query
            }, newAsPath, {
                shallow: true
            });
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Product_Page, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        onAttributeChangeHandler: onAttributeChangeHandler
    }));
};
var ProductPage = function(param) {
    var product = param.data, showRecommendations = param.showRecommendations;
    var ref, ref1;
    var ref2 = (0,lib.useCart)(), addItemToCheckout = ref2.addItemToCheckout, items = ref2.items, removeItem = ref2.removeItem, loaded = ref2.loaded;
    var user = (0,lib.useAuth)().user;
    var login = (0,useLogin/* default */.Z)().login;
    var ref3 = (0,TikTokPixelProvider/* useTikTokPixelContext */.n)(), clientIpAddress = ref3.clientIpAddress, trackProduct = ref3.trackProduct;
    var router = (0,next_router.useRouter)();
    var push = (0,DatalayerProvider/* useDatalayer */.t)().push;
    (0,react.useEffect)(function() {
        if (product && clientIpAddress) {
            trackProduct("ViewContent", product);
        }
    }, [
        product,
        clientIpAddress
    ]);
    var canEdit = (product === null || product === void 0 ? void 0 : product.id) && user && (user.isStaff || (product === null || product === void 0 ? void 0 : (ref = product.lender) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.id) === user.id);
    var editLink = canEdit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.EditProductLink, {
        productId: product.id
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
    var canDisplayProduct = canDisplay(product);
    (0,react.useEffect)(function() {
        if (canDisplayProduct && product) {
            (0,facebook/* sendFacebookViewContentEvent */.AA)(product, user);
        }
    }, [
        canDisplayProduct,
        product
    ]);
    (0,react.useEffect)(function() {
        if (canDisplayProduct && product) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
            var selectedVariant = (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0];
            var variantPrice = ((selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.pricing) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.price) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.gross) === null || ref3 === void 0 ? void 0 : ref3.amount) || 0) + ((selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref4 = selectedVariant.pricing) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.borrowerFee) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.gross) === null || ref6 === void 0 ? void 0 : ref6.amount) || 0);
            push({
                event: "view_item",
                ecommerce: {
                    currency: (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref7 = selectedVariant.pricing) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.price) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.gross) === null || ref9 === void 0 ? void 0 : ref9.currency) || "",
                    value: variantPrice,
                    items: [
                        {
                            item_id: (0,base64/* decodeBase64Id */.n)(product.id),
                            item_name: product.name,
                            item_brand: (0,getAttributeValue/* getAttributeValue */.k)("designer", product.attributes),
                            item_category: ((ref10 = product.category) === null || ref10 === void 0 ? void 0 : ref10.name) || "",
                            item_variant: "Size ".concat((0,getAttributeValue/* getAttributeValue */.k)("size", product.attributes)),
                            price: variantPrice,
                            quantity: 1
                        }, 
                    ]
                }
            });
        }
    }, [
        canDisplayProduct,
        product
    ]);
    var addItemToCheckoutWithFacebookEvent = function(params) {
        if (product) {
            (0,facebook/* sendFacebookAddToCartEvent */.Lj)(product, params.variantId, user);
            return addItemToCheckout(params);
        }
    };
    var ref4 = (0,react.useState)(function() {
        var ref;
        if ((user === null || user === void 0 ? void 0 : (ref = user.wishlist) === null || ref === void 0 ? void 0 : ref.edges) && product && user.wishlist.edges.some(function(item) {
            return item.node.productId === product.id;
        })) {
            return true;
        }
        return false;
    }), isInWishlist = ref4[0], setIsInWishlist = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,lib.useAddProductToWishlist)(null, {
        refetchQueries: [
            "UserDetails"
        ]
    }), 2), addProductToWishlist = ref5[0], ref6 = ref5[1], addToWishlistLoading = ref6.loading;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,lib.useRemoveProductFromWishlist)(null, {
        refetchQueries: [
            "UserDetails"
        ]
    }), 2), removeProductFromWishlist = ref7[0], ref8 = ref7[1], removeFromWishLoading = ref8.loading;
    var wishListLoading = addToWishlistLoading || removeFromWishLoading;
    var toggleWishlist = function() {
        if ((user === null || user === void 0 ? void 0 : user.id) && product) {
            if (isInWishlist) {
                if (!wishListLoading) {
                    removeProductFromWishlist({
                        productId: product.id
                    });
                    setIsInWishlist(false);
                }
            } else if (!wishListLoading) {
                trackProduct("AddToWishlist", product, true);
                addProductToWishlist({
                    productId: product.id,
                    productSlug: product.slug
                });
                setIsInWishlist(true);
            }
        } else {
            login({
                addToWishlist: "true"
            });
        }
    };
    (0,react.useEffect)(function() {
        if ((user === null || user === void 0 ? void 0 : user.id) && router.query.addToWishlist === "true" && !wishListLoading && product) {
            addProductToWishlist({
                productId: product.id,
                productSlug: product.slug
            });
            setIsInWishlist(true);
        }
    }, [
        user,
        router.query
    ]);
    var pathname = router.pathname;
    var productSlug = (product === null || product === void 0 ? void 0 : product.slug) || "";
    var basePath = "".concat(constants/* siteUrl */.or).concat(pathname);
    var canonicalUrl = basePath.replace(/\[slug\]/g, productSlug);
    if (!product || (0,lodash.isEmpty)(product)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy.NotFound, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy.MetaWrapper, {
        meta: extractMeta(product, canonicalUrl),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageWithQueryAttributes, {
            product: product,
            add: addItemToCheckoutWithFacebookEvent,
            items: items,
            editLink: editLink,
            toggleWishlist: toggleWishlist,
            isInWishlist: isInWishlist,
            user: user,
            removeItem: removeItem,
            showRecommendations: showRecommendations,
            loaded: loaded
        })
    });
};

;// CONCATENATED MODULE: ./src/views/Product/index.tsx


;// CONCATENATED MODULE: ./src/pages/item/[slug].ts

var __N_SSP = true;
/* harmony default export */ var _slug_ = (ProductPage);


/***/ }),

/***/ 74858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AA": function() { return /* binding */ sendFacebookViewContentEvent; },
/* harmony export */   "Lj": function() { return /* binding */ sendFacebookAddToCartEvent; },
/* harmony export */   "a4": function() { return /* binding */ sendFacebookPurchaseEvent; }
/* harmony export */ });
/* harmony import */ var _rivercode_facebook_conversion_api_nextjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51046);

var Event;
(function(Event) {
    Event["ViewContent"] = "ViewContent";
    Event["AddToCart"] = "AddToCart";
    Event["Purchase"] = "Purchase";
    Event["InitiateCheckout"] = "InitiateCheckout ";
})(Event || (Event = {}));
var sendFacebookViewContentEvent = function(product, user) {
    try {
        if (product) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
            (0,_rivercode_facebook_conversion_api_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .fbEvent */ .z$)({
                eventName: Event.ViewContent,
                // eventId: 'eventId', // optional, unique event id's will be generated by default
                emails: user ? [
                    user.email
                ] : [],
                // phones: ['phone1', 'phone2'], // optional
                products: product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref.map(function(pv) {
                    return {
                        sku: (pv === null || pv === void 0 ? void 0 : pv.sku) || "",
                        quantity: 1
                    };
                }),
                value: (product === null || product === void 0 ? void 0 : (ref1 = product.pricing) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.priceRange) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.start) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.gross) === null || ref4 === void 0 ? void 0 : ref4.amount) || 0,
                currency: (product === null || product === void 0 ? void 0 : (ref5 = product.pricing) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.priceRange) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.start) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.gross) === null || ref8 === void 0 ? void 0 : ref8.currency) || "AUD",
                enableStandardPixel: true
            });
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
    }
};
var sendFacebookAddToCartEvent = function(product, variantId, user) {
    try {
        if (product) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            var variant = product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref.find(function(pv) {
                return (pv === null || pv === void 0 ? void 0 : pv.id) === variantId;
            });
            var eventData = {
                eventName: Event.AddToCart,
                // eventId: 'eventId', // optional, unique event id's will be generated by default
                emails: user ? [
                    user.email
                ] : [],
                // phones: ['phone1', 'phone2'], // optional
                products: [
                    {
                        sku: variant === null || variant === void 0 ? void 0 : variant.sku,
                        quantity: 1
                    }
                ],
                value: (variant === null || variant === void 0 ? void 0 : (ref1 = variant.pricing) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.price) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.gross) === null || ref3 === void 0 ? void 0 : ref3.amount) || 0,
                currency: variant === null || variant === void 0 ? void 0 : (ref4 = variant.pricing) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.price) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.gross) === null || ref6 === void 0 ? void 0 : ref6.currency,
                enableStandardPixel: true
            };
            (0,_rivercode_facebook_conversion_api_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .fbEvent */ .z$)(eventData);
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
    }
};
var sendFacebookPurchaseEvent = function(items, totalPrice, checkout) {
    try {
        if (items.length) {
            var eventData = {
                eventName: Event.Purchase,
                // eventId: 'eventId', // optional, unique event id's will be generated by default
                emails: (checkout === null || checkout === void 0 ? void 0 : checkout.email) ? [
                    checkout.email
                ] : [],
                // phones: ['phone1', 'phone2'], // optional
                products: items.map(function(i) {
                    return {
                        sku: i.variant.sku,
                        quantity: i.quantity
                    };
                }),
                value: totalPrice.gross.amount,
                currency: totalPrice.gross.currency,
                enableStandardPixel: true
            };
            (0,_rivercode_facebook_conversion_api_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .fbEvent */ .z$)(eventData);
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
    }
};


/***/ }),

/***/ 6360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ getAttributeValue; }
/* harmony export */ });
var getAttributeValue = function(attrName, attributes) {
    var ref, ref1, ref2;
    if (!attributes) return "";
    var ref3;
    return (ref3 = (ref = attributes.find(function(attr) {
        return attr.attribute.slug === attrName;
    })) === null || ref === void 0 ? void 0 : (ref1 = ref.values) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.name) !== null && ref3 !== void 0 ? ref3 : "";
};


/***/ }),

/***/ 78676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ productList; },
/* harmony export */   "k": function() { return /* binding */ useProductsQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22841);
/* harmony import */ var _app_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);
/* harmony import */ var _graphql_fragments__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7905);
/* harmony import */ var _graphql_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23149);
/* harmony import */ var _temp_core_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32236);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  query ProductList(\n    $after: String\n    $first: Int!\n    $sortBy: ProductOrder\n    $filter: ProductFilterInput\n    $channel: String\n    $queryType: String\n    $filterIsb: Boolean\n    $similarProductId: ID\n  ) {\n    products(\n      after: $after\n      first: $first\n      sortBy: $sortBy\n      filter: $filter\n      channel: $channel\n      public: true\n      queryType: $queryType\n      filterIsb: $filterIsb\n      similarProductId: $similarProductId\n    ) {\n      edges {\n        node {\n          ...BasicProductFields\n          ...ProductPricingFieldSF\n          ...ShippingMethods\n        }\n      }\n      totalCount\n      pageInfo {\n        ...PageInfo\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var productList = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_5__["default"])(_templateObject(), _graphql_fragments__WEBPACK_IMPORTED_MODULE_2__/* .basicProductFragment */ .kf, _graphql_fragments__WEBPACK_IMPORTED_MODULE_2__/* .productPricingFragment */ .XA, _graphql_fragments__WEBPACK_IMPORTED_MODULE_2__/* .shippingMethodsFragment */ .v6, _graphql_fragments__WEBPACK_IMPORTED_MODULE_2__/* .pageInfo */ .x1);
var useProductsQuery = function(filters, ids) {
    var after = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : undefined, postcodes = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], lenderSlug = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", qType = arguments.length > 5 ? arguments[5] : void 0;
    var ref, ref1, ref2;
    var categoryId = ids.categoryId, collectionId = ids.collectionId;
    var categorySlugs = filters.categorySlugs;
    var variables = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        filter: {
            prices: filters === null || filters === void 0 ? void 0 : (ref = filters.prices) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                var lte = param.lte, gte = param.gte;
                return {
                    lte: lte,
                    gte: gte
                };
            }),
            lenderRating: {
                gte: ((ref2 = filters === null || filters === void 0 ? void 0 : (ref1 = filters.lenderRating) === null || ref1 === void 0 ? void 0 : ref1.sort(function(a, b) {
                    return a - b;
                })) === null || ref2 === void 0 ? void 0 : ref2[0]) || null
            },
            lenderSlug: lenderSlug,
            collections: collectionId && qType !== "warehouse_sale" ? [
                collectionId
            ] : undefined,
            categories: categoryId && !categorySlugs ? [
                categoryId
            ] : undefined,
            channel: _app_constants__WEBPACK_IMPORTED_MODULE_1__/* .channelSlug */ .m_,
            attributes: filters.attributes ? (0,_temp_core_utils__WEBPACK_IMPORTED_MODULE_4__/* .convertToAttributeScalar */ .rh)(filters.attributes) : {},
            postcodes: postcodes.length ? postcodes : filters.postcodes,
            availableDeliveryDate: filters.availableDeliveryDate,
            availableDeliveryPostcode: filters.availableDeliveryPostcode,
            search: filters === null || filters === void 0 ? void 0 : filters.search,
            categorySlugs: categorySlugs
        },
        channel: _app_constants__WEBPACK_IMPORTED_MODULE_1__/* .channelSlug */ .m_,
        first: filters.pageSize || _app_constants__WEBPACK_IMPORTED_MODULE_1__/* .productsPerPage */ .ct,
        after: after || undefined,
        sortBy: (0,_temp_core_utils__WEBPACK_IMPORTED_MODULE_4__/* .convertSortByFromString */ .dz)((filters === null || filters === void 0 ? void 0 : filters.sortBy) || ""),
        public: true,
        queryType: qType,
        filterIsb: (filters === null || filters === void 0 ? void 0 : filters.filterIsb) || false
    }, (filters === null || filters === void 0 ? void 0 : filters.similarProductId) && {
        similarProductId: filters.similarProductId
    });
    return (0,_graphql_queries__WEBPACK_IMPORTED_MODULE_3__/* .useTypedQuery */ .OK)(productList, {
        variables: variables,
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
        returnPartialData: true,
        skip: false
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4738,594,3662,4396,4817,4838,1255,8527,8547,1664,1448,5534,7947,4273,2036,6629,6467,3920,7801,5861,8557,9774,2888,179], function() { return __webpack_exec__(30052); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);